"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CalendarEventOptionalSchema () {
        return CalendarEventOptionalSchema;
    },
    get CalendarEventSchema () {
        return CalendarEventSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const CalendarEventSchema = _zod.z.object({
    /**
	 * The external calendar event ID from the provider (Google, Outlook, etc.)
	 */ event_id: _zod.z.string(),
    /**
	 * The calendar provider that hosts this event
	 */ provider: _zod.z.enum([
        "google",
        "outlook"
    ]),
    /**
	 * The calendar ID within the provider where this event is stored
	 */ calendar_id: _zod.z.string(),
    /**
	 * The recurring series that owns this occurrence link. Standalone events omit it.
	 * This provenance is required because provider + calendar ID cannot distinguish
	 * two Google users whose selected calendar is both named "primary".
	 */ recurring_series_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    /**
	 * The recurring master that produced this occurrence. Cleanup uses this provenance so
	 * a delayed task for an older master cannot unlink a replacement master's occurrence.
	 */ recurring_master_event_id: _zod.z.string().optional(),
    /**
	 * The integration owner whose tokens can reach this native occurrence.
	 * Stored on the link because a later reattach can change the series owner while
	 * retained historical occurrences still belong to the original owner's calendar.
	 */ integration_owner_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    /**
	 * When this calendar event record was first created
	 */ created: _zod.z.instanceof(Date),
    /**
	 * When this calendar event record was last updated
	 */ updated: _zod.z.instanceof(Date)
});
const CalendarEventOptionalSchema = CalendarEventSchema.optional();
